import { render, staticRenderFns } from "./NewClientModal.vue?vue&type=template&id=bded8256&scoped=true&"
import script from "./NewClientModal.vue?vue&type=script&lang=js&"
export * from "./NewClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bded8256",
  null
  
)

export default component.exports